import WorkIcon from '@mui/icons-material/Work';
import SchoolIcon from '@mui/icons-material/School';

export const TimelineList = [
      {
        date: "2020-nu",
        title: "Thomas More Hogeschool",
        place: "Geel, België",
        explanation:"Bachelor in Elektronica-ICT. Digital Innovation/IoT",
        icon:<SchoolIcon/>,
        color:"rgb(19, 168, 158)",
      },
      {
        date: "2020-nu",
        title: "gestart met freelancen",
        place: "België, Nederland",
        explanation:"EMG Netherlands, FlyAway, Mediapro",
        icon:<WorkIcon/>,
        color:"rgb(168,158,19)",
      },
      {
        date: "2017-2020",
        title: "Karel de Grote Hogeschool",
        place: "Hoboken, België",
        explanation:"Bachelor diploma Multimedia en Communicatie Technologie. Audio-Video",
        icon:<SchoolIcon/>,
        color:"rgb(19, 168, 158)",
      }
];